import React, {
  useState,
  useEffect,
  useMemo,
  Fragment,
  useCallback,
} from "react";
import {
  Autocomplete,
  Grid,
  TextField,
  CircularProgress,
  LinearProgress,
} from "@mui/material";
import ReactPaginate from "react-paginate";
import Table from "../../Components/Common/Table/Table";
import {
  getInfoMessageNoResultsSearch,
  CommonSubHeader,
} from "../../Components/helpers/Helpers";
import Swal from "sweetalert2";
import TableActions from "../../Components/Common/Table/TableActions";
import api from "../../api/axios";

function HojasDeEncargo({ flagToShow = true }) {
  const [contracts, setContracts] = useState([]);
  const [objPerPage, setObjPerPage] = useState(10);
  const [pagePressed, setPagePressed] = useState(1);
  const [totalPagesNumber, setTotalPagesNumber] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [flag, setFlag] = useState(false);

  const [filters, setFilters] = useState({
    company: 0,
  });

  const [options, setOptions] = useState({
    companies: [],
  });

  const [loadingOptions, setLoadingOptions] = useState({
    companies: false,
  });

  const contractsData = useCallback(async () => {
    setFlag(true);
    try {
      const response = await api.post(
        process.env.REACT_APP_API_URL + "/contracts",
        {
          page: pagePressed,
          objPerPage,
          ...filters,
        },
      );

      const { contracts, companies } = response.data;

      console.log(contracts);

      companies.unshift({ company_name: "Seleccionar", id: 0 });

      setContracts(contracts.data);
      setPageCount(contracts.last_page);
      setTotalPagesNumber(contracts.total);
      setOptions((prev) => ({ ...prev, companies }));
    } catch (error) {
      console.error("Error fetching contracts:", error);
      Swal.fire({
        icon: "error",
        title: "Error en el servidor",
        text: "Hubo un problema al cargar los datos.",
      });
    } finally {
      setFlag(false);
    }
  }, [pagePressed, objPerPage, filters]);

  useEffect(() => {
    contractsData();
  }, [contractsData]);

  const handlePageClick = (event) => setPagePressed(event.selected + 1);

  const handleFilterChange = (name, value) => {
    setFilters((prev) => ({ ...prev, [name]: value }));
    if (name === "objPerPage") {
      setObjPerPage(value > totalPagesNumber ? totalPagesNumber : value);
    }
  };

  const renderCellWithDefault = (value, defaultValue = "--") => (
    <div className="spanClassForTables" style={{ paddingLeft: "20px" }}>
      {value || defaultValue}
    </div>
  );

  const renderLogoCell = (value) => (
    <div className="spanClassForTables">
      {ImageCell(value) || "Sin asignar"}
    </div>
  );

  const ImageCell = (value) => {
    const [esImagenValida, setEsImagenValida] = useState(null);
    const url = `${process.env.REACT_APP_BACKEND_HOST}/storage/company/${value.id}/${value.company_logo}`;

    useEffect(() => {
      if (!url) return;

      const img = new Image();

      img.onload = () => setEsImagenValida(true);
      img.onerror = () => setEsImagenValida(false);
      img.src = url;

      // Opcional: limpiar cuando el componente se desmonta
      return () => {
        img.onload = null;
        img.onerror = null;
      };
    }, [url]);

    if (esImagenValida === null)
      return <div style={{ textAlign: "center" }}>Validando...</div>;

    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          justifyContent: "center",
        }}>
        {esImagenValida === false ? (
          <div></div>
        ) : (
          <img src={url} alt="Company logo" style={{ height: "30px" }} />
        )}

        <b>{value.company_name}</b>
      </div>
    );
  };

  const columns = useMemo(
    () => [
      {
        Header: "LISTA DE HOJAS DE ENCARGO",
        columns: [
          {
            Header: "Empresa",
            accessor: "company_relation",
            width: 200,
            Cell: ({ value }) => renderLogoCell(value),
          },
          {
            Header: "Hoja de Encargo/Contrato",
            accessor: "contract_title",
            width: 500,
            Cell: ({ value }) => renderCellWithDefault(value),
          },
          // {
          //   Header: "Acciones",
          //   accessor: "id",
          //   Cell: ({ value }) => (
          //     <TableActions rute={"contratos"} value={value} />
          //   ),
          // },
        ],
      },
    ],
    [],
  );

  const fieldsConfig = [
    {
      type: "autocomplete",
      label: "Empresas",
      options: options.companies || [], // Asegura que sea un array
      loading: loadingOptions.companies,
      onChange: (_, value) =>
        handleFilterChange("company", value ? value.id : 0), // Manejar el caso cuando value es null
      getOptionLabel: (option) => option.company_name || "", // Controla casos sin datos
    },
  ];

  const renderField = (field, index) => (
    <Grid
      item
      xs={4}
      md={2}
      key={index}
      textAlign="left"
      sx={{ padding: "5px" }}>
      <Autocomplete
        size="small"
        className={field.className}
        options={field.options || []} // Asegura que sea un array
        loading={field.loading}
        onChange={field.onChange}
        getOptionLabel={field.getOptionLabel}
        renderInput={(params) => (
          <TextField
            {...params}
            label={field.label}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <Fragment>
                  {field.loading && (
                    <CircularProgress color="inherit" size={20} />
                  )}
                  {params.InputProps.endAdornment}
                </Fragment>
              ),
            }}
          />
        )}
      />
    </Grid>
  );

  useEffect(() => {
    if (pagePressed > pageCount) {
      setPagePressed(1);
    }
  }, [pageCount]);

  const content = (
    <div className="fatherContainer">
      <div className="mainContainer">
        <div className="subMainContainer">
          {(contracts === "" || flag) && <LinearProgress color="success" />}
          <Grid
            container
            direction="row"
            m={"10px 0"}
            item
            xs={12}
            className="filtersContainer">
            {fieldsConfig.map(renderField)}
          </Grid>
          {contracts && !flag && (
            <>
              <Table
                columns={columns}
                data={contracts}
                view={"contrato"}
                viewTitle={"contratos"}
                totalPagesNumber={totalPagesNumber}
                tableWidth={"unset"}
                minTableWidth={"90%"}
              />
              {totalPagesNumber > 10 && (
                <div className="tablePaginateContainer">
                  <div className="paginatorLeftText">
                    Mostrando {objPerPage * (pagePressed - 1) + 1} a{" "}
                    {Math.min(objPerPage * pagePressed, totalPagesNumber)} de{" "}
                    {totalPagesNumber} resultados
                  </div>
                  <ReactPaginate
                    breakLabel="..."
                    nextLabel="Siguiente 🢂"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={2}
                    pageCount={pageCount}
                    previousLabel="🢀 Anterior"
                    containerClassName="pagination"
                    activeClassName="active"
                    pageClassName="page-item"
                    nextClassName="page-item"
                    previousClassName="page-item"
                    disabledClassName="disabled"
                    forcePage={pagePressed - 1}
                  />
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <>
      {flagToShow ? (
        <div>
          <CommonSubHeader
            title="Configuración"
            subTitle="Hojas de Encargo - Contratos"
          />

          {content}
        </div>
      ) : (
        <div className="fatherContainer">
          <div className="mainContainer">{content}</div>
        </div>
      )}
    </>
  );
}

export default HojasDeEncargo;
